import React, { useEffect } from "react"

import Icon from "../icons/Icon"
import {IToastMessage} from "../../../interfaces/toasts/toasts";


export const ToastMessage = ({showToast =true, closeToast, toastOptions, children}:IToastMessage) => {
    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                closeToast();
                toastOptions?.toastCompletionCallback?.()
            }, 5000)
        }
    },[showToast])

    if (!showToast) {
        return <></>
    }

    return (
        <div className={"tcl-toast-wrapper"}>
             <div className={`tcl-toast ${toastOptions?.type}`}>
                {!!toastOptions?.icon && <div><Icon iconName={toastOptions?.icon} sizeInPx={"20"} color="var(--thriveWhite)"/> </div>}
                <div>{children}</div>
            </div>
        </div>
       
    )
}